import { useBreakpoint } from '@vivino/js-react-common-ui';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Anchor from 'vivino-js/atoms/Anchor';
import { KnowledgeBaseUrls, getKnowledgeBaseFullUrl } from 'vivino-js/staticLinks';
import t from 'vivino-js/translationString';
import ToolTip, { ToolTipPosition } from 'vivino-ui/atoms/ToolTip';
import ShippingTimeIcon from 'vivino-ui/icons/ShippingTime';
import ThermometerIcon from 'vivino-ui/icons/Thermometer';

import styles from './temperatureControlInformation.scss';

const TRANSLATIONS_PATH = 'components.temperature_control_information';

const TRANSLATIONS = {
  temperatureControllledShipping: `${TRANSLATIONS_PATH}.temperature_controlled_shipping`,
  temperature: `${TRANSLATIONS_PATH}.temperature`,
  transport: `${TRANSLATIONS_PATH}.transport`,
  readMore: `${TRANSLATIONS_PATH}.read_more`,
};

const TemperatureControlInformation = ({ show, onClose }) => {
  const { isTablet } = useBreakpoint();

  if (!show) {
    return null;
  }

  return (
    <div className={styles.temperatureControlInformation}>
      <ToolTip show={show} onClose={onClose} position={isTablet ? ToolTipPosition.Left : null}>
        <div className={styles.textContainer}>
          <div className={styles.header}>{t(TRANSLATIONS.temperatureControllledShipping)}</div>

          <div className={styles.paragraph}>
            <div className={styles.icon}>
              <ThermometerIcon className={styles.icon} />
            </div>
            <div className={styles.iconText}>{t(TRANSLATIONS.temperature)}</div>
          </div>

          <div className={styles.paragraph}>
            <div className={cx(styles.icon, styles.truck)}>
              <ShippingTimeIcon className={styles.icon} />
            </div>
            <div className={styles.iconText}>{t(TRANSLATIONS.transport)}</div>
          </div>

          <Anchor
            href={getKnowledgeBaseFullUrl(KnowledgeBaseUrls.TemperatureControlledShipping)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className={styles.readMore}>{t(TRANSLATIONS.readMore)}</span>
          </Anchor>
        </div>
      </ToolTip>
    </div>
  );
};

TemperatureControlInformation.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

export default TemperatureControlInformation;
